export default __webpack_public_path__ + "static/landing-section-5-7e3576d05992f9f4e3e5a2469ebea28a.png";